
import { footer } from '../customWhiteLabel'
export default {
  data() {
    return {
      dataForm: {},
      loadingBtn: false,
      colorGradient: '',
      rules: {
        ticket: [
          (v) => !!v || 'O campo Ticket é obrigatório',
          (v) =>
            (v && v.length === 11 && /^\d+$/.test(v)) ||
            'O Ticket deve ter exatamente 11 dígitos numéricos',
        ],
      },
      footer,
    }
  },
  head() {
    return {
      title: 'Renovação Online',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'Agregue valor para seu negócio seja um indicador de Certificado Digital',
        },
      ],
    }
  },

  methods: {
    save() {
      console.log(this.dataForm)
    },
    redirecionarCompra() {
      this.$router.push('/')
    },
    handleRenewal() {
      const validate = this.$refs.form.validate()
      if (!validate) {
        return false
      }

      const codigo = this.dataForm.ticket
      const url = `https://renovar.vpki.com.br/renovar-endEntity/pages/public/client/testDeviceComputer.jsf?faces-redirect=true&rd=RD01&store=RD01&campaign=151&partnerCode=&skin=&ticket=${codigo}`
      window.location.href = url
    },
  },
}
